import { useQuery } from 'react-query';

import config from '../config';
import { useUserApi } from './api';

/**
 * Finds a Goodfynd user by unique identifier
 * @param userId Can be email, handle, or ID
 * @returns
 */
export default function useUserExists(userId: string) {
  const authApi = useUserApi();
  const { isFetched, isFetching, isLoading, refetch, error } = useQuery<
    ResponseBase,
    unknown
  >(
    [config.queryKeys.authUser, userId],
    async () => await authApi.accountExists(userId),
    {
      enabled: !!userId,
    }
  );

  return {
    checkAgain: refetch,
    exists: isFetching || !userId ? undefined : !error,
    isFetched,
    isFetching,
    isLoading,
  };
}
